import { AfterNotifyHandler } from "@honeybadger-io/core/build/src/types"
// only place this should be used
// eslint-disable-next-line no-restricted-imports
import { HoneybadgerErrorBoundary } from "@honeybadger-io/react"

import { isServerSide } from "@/lib/is-server-side"

// Overriding this class to remove the notify handler when the component is unmounted this is to prevent memory leaks on
// the server side, withouth this change every request would add a new notify handler to the honeybadger instance and
// never remove it
export class MindtripErrorBoundary extends HoneybadgerErrorBoundary {
  private readonly notifyHandler: AfterNotifyHandler | null = null

  constructor(
    props: ConstructorParameters<typeof HoneybadgerErrorBoundary>[0]
  ) {
    super(props)
    this.notifyHandler =
      this.props.honeybadger["__afterNotifyHandlers"][
        this.props.honeybadger["__afterNotifyHandlers"].length - 1
      ]
    if (isServerSide()) {
      this.cleanupNotifyHandler()
    }
  }

  componentDidMount() {
    if (!this.notifyHandler) {
      console.warn("warning no notify handler")
    }
  }

  componentWillUnmount() {
    this.cleanupNotifyHandler()
  }

  private cleanupNotifyHandler() {
    this.props.honeybadger["__afterNotifyHandlers"] = this.props.honeybadger[
      "__afterNotifyHandlers"
    ].filter((handler) => handler !== this.notifyHandler)
  }
}
